import { FC, memo } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { TouchableRipple } from 'react-native-paper'
import { SvgProps } from 'react-native-svg'
import { ColorsEnum } from '../../../constants/colors'
import { FontsEnum } from '../../../constants/fonts'

interface TabProps {
    children: string
    selected: boolean
    index: number
    color: string
    onPress: (index: number) => void
    Icon?: FC<SvgProps>
}

const Tab: FC<TabProps> = ({ children, selected, index, color, onPress, Icon }) => {
    const handlePress = () => {
        onPress(index)
    }

    return (
        <TouchableRipple onPress={handlePress}>
            <View
                style={[
                    styles.container,
                    selected && styles.selected,
                    selected && { borderBottomColor: color },
                ]}
            >
                {Icon && (
                    <Icon
                        fill={selected ? color : ColorsEnum.GRAY_DARK}
                        style={{ marginRight: 6 }}
                    />
                )}
                <Text style={[styles.title, selected && { color }]}>{children}</Text>
            </View>
        </TouchableRipple>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minWidth: 108,
    },
    title: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 16,
    },
    selected: {
        borderBottomWidth: 4,
    },
})

export default memo(Tab)
